import { useIntl } from "react-intl";

const ReleaseTracks = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ReleaseTracks.header",
            defaultMessage: "Release tracks"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ReleaseTracks.body",
            defaultMessage:
                "Control when and how changes are released to end users with Release Tracks."
        }),
        body2: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ReleaseTracks.body2",
            defaultMessage:
                "With options to control Atlassian cloud releases, your day-to-day management of our cloud products becomes more predictable, helping you plan, prepare, and ensure success for upcoming product changes."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
        </>
    );
};

export default ReleaseTracks;
